/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class TaskStateIds {
    static readonly new: string = "822c9874-750d-4142-857d-c5fed808b5f5";
    static readonly inProgress: string = "d5d54e33-2c2c-41ca-9d7c-86dd2742c1ee";
    static readonly awaitingResponse: string = "744c6fad-c04c-458e-a0eb-243a2a6c97e7";
    static readonly closedIncomplete: string = "54eab322-f36e-4a62-9f01-623eefa94da6";
    static readonly closedComplete: string = "9c562024-739f-480a-893c-4b61cb7002f8";
    static inProgressStates: string[] = ["d5d54e33-2c2c-41ca-9d7c-86dd2742c1ee","744c6fad-c04c-458e-a0eb-243a2a6c97e7"];
}
